function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var l = Object.defineProperty;
var C = Object.getOwnPropertySymbols;
var w = Object.prototype.hasOwnProperty,
    L = Object.prototype.propertyIsEnumerable;

var e = function e(n, t, o) {
  return t in n ? l(n, t, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: o
  }) : n[t] = o;
},
    i = function i(n, t) {
  for (var o in t || (t = {})) {
    w.call(t, o) && e(n, o, t[o]);
  }

  if (C) {
    var _iterator = _createForOfIteratorHelper(C(t)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var o = _step.value;
        L.call(t, o) && e(n, o, t[o]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return n;
};

import * as r from "react";

function h(n) {
  return r.createElement("svg", i({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, n), r.createElement("path", {
    d: "M12.5825 5L12.5825 16.17L17.4625 11.29C17.8525 10.9 18.4925 10.9 18.8825 11.29C19.2725 11.68 19.2725 12.31 18.8825 12.7L12.2925 19.29C11.9025 19.68 11.2725 19.68 10.8825 19.29L4.29252 12.7C3.90252 12.31 3.90252 11.68 4.29252 11.29C4.68252 10.9 5.31252 10.9 5.70252 11.29L10.5825 16.17L10.5825 5C10.5825 4.45 11.0325 4 11.5825 4C12.1325 4 12.5825 4.45 12.5825 5Z",
    fill: "black"
  }));
}

export { h as ReactComponent };